import React, { Component } from "react";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import PageDesigner from "../page_designer/PageDesigner";
import TemplateManager from "./templates/TemplateManager";
import { PAGE_TYPE } from "../page_designer/ComponentList";
import SavePopup from "../common/SavePopup";
import FormManager from "./FormManager";
import FormService from "../../services/form";
import FormHeader from "./FormHeader";
import ComponentManager from "../page_designer/ComponentManager";
import {
  showToast,
  TOAST_TYPE,

} from "deskera-ui-library";
import Utility from "../../utility/Utility";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import { find } from "rxjs";

export default class FormBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSegment: 0,
      jsonData: FormManager.isPageDataAvailable()
        ? FormManager.getFormJSONData()
        : TemplateManager.getTemplate(),
      needSaveButton: true,
      needSavePopup: false,
      needSharePopup: false,
      newComponent: null
    };

    this.pageDataToSave = null;
    this.pageType = PAGE_TYPE.FORM;
  }

  componentDidMount() {
    RouteManager.setPresenter(this);
    FormService.getPipelineData();
    if (!FormManager.isPageDataAvailable() && this.props.match.params.id) {
      FormManager.fetchPageDataById(this.props.match.params.id, () => {
        this.setState({ jsonData: FormManager.getFormJSONData() });
      });
    }
  }

  render() {
    return (
      <div className="parent-width align-items-start parent-height">
        <FormHeader
          title={"Form Designer"}
          stepperIndex={1}
          onSave={this.saveTapped}
          onAdd={this.componentAdded}
        />
        <PageDesigner
          type={this.pageType}
          components={
            Array.isArray(this.state.jsonData)
              ? this.state.jsonData
              : this.state.jsonData.designElements
          }
          scripts={this.state.jsonData.scripts}
          metaData={this.state.jsonData.metaData}
          hash={this.state.jsonData.hash}
          addComponent={this.state.newComponent}
          onDataChange={(data) => {
            this.pageDataToSave = data;
          }}
          onSave={() => {
            this.saveTapped();
          }}
        />
        {this.state.needSavePopup && this.getSavePopup()}
      </div>
    );
  }

  saveTapped = () => {
    if (FormManager.isPageDataAvailable()) {
      this.updateForm();
    } else {
      this.showSavePopup();
    }
  };

  componentAdded = (type) => {
    this.setState({ newComponent: type })
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getSavePopup() {
    return (
      <SavePopup
        title="New Form"
        header="Form Name"
        headerIcon="📝 "
        subHeader="Enter a name to help you remember what this form is all about. Only you will see this."
        onCancel={this.onPopupCancel}
        onSave={this.onPopupSave}
        allowDomainSelection={true}
      />
    );
  }

  //////////////////////////////////////////////////////

  showSavePopup = () => {
    if(this.pageDataToSave.json.designElements.length === 0) {
      showToast("Please add elements from right panel", TOAST_TYPE.FAILURE);
      return
    }
    this.setState({
      needSavePopup: true,
    });
  };
  hideSavePopup = () => {
    this.setState({
      needSavePopup: false,
    });
  };

  //////////////////////////////////////////////////////

  onPopupSave = (title, domain) => {
    this.saveForm(title, domain);
  };
  onPopupCancel = () => {
    this.hideSavePopup();
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  saveForm(title, domain) {
    let data = {
      ...ComponentManager.getEncodedDataToSave(
        this.pageDataToSave,
        this.pageType
      ),
      formName: title,
      domain: domain,
    };
    const request = FormManager.getRequestToSaveForm(data);
    FormService.save(
      request,
      (data) => {
        this.formSaved(data);
      },
      (error) => {
        if (typeof error === "string" && error.length > 0) {
          showToast(error, TOAST_TYPE.FAILURE);
        } else {
          showToast("Internal server error, please try again later.", TOAST_TYPE.FAILURE);
        }
        this.hideSavePopup();
      }
    );
  }

  updateForm() {
    if(Utility.isEmpty(this.pageDataToSave.segmentId)) {
      this.pageDataToSave.segmentId = [1];
    } else if(Array.isArray(this.pageDataToSave.segmentId)) {
      let filteredSegment = [];
      const jobOpeningColumn = TableManger.getColumn(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING)
      if(Array.isArray(jobOpeningColumn.options)) {
        this.pageDataToSave.segmentId?.forEach(id=>{
          if(jobOpeningColumn.options.find(option=>option.id === id)) {
            filteredSegment.push(id);
          }
        })
      }
      if(Utility.isEmpty(filteredSegment)) {
        filteredSegment = [1]
      }
      this.pageDataToSave.segmentId = filteredSegment;
      if(Array.isArray(this.pageDataToSave?.json?.designElements)) {
        const formIndex = this.pageDataToSave.json.designElements.findIndex(element=> element.type === 'Form') || -1
        if(formIndex !== -1) {
          this.pageDataToSave.json.designElements[formIndex].segmentId = filteredSegment;
          this.pageDataToSave.json.designElements[formIndex].selectedSegmentData = this.pageDataToSave.json.designElements[formIndex].selectedSegmentData.filter(d=>filteredSegment.find(f=>f === d.id))
        }
      }
    }
    const request = FormManager.getRequestToUpdateForm(
      ComponentManager.getEncodedDataToSave(this.pageDataToSave, this.pageType)
    );
    FormService.update(
      request,
      FormManager.getFormRecordId(),
      (data) => {
        this.formSaved(data);
      },
      (error) => {
        if (typeof error === "string" && error.length > 0) {
          showToast(error, TOAST_TYPE.FAILURE);
        } else {
          showToast("Internal server error, please try again later.", TOAST_TYPE.FAILURE);
        }
        RouteManager.navigateToPage(PAGE_ROUTES.JOB_FORMS);
      }
    );
  }

  formSaved(data) {
    FormManager.setFormData(data);
    RouteManager.navigateToPage(
      PAGE_ROUTES.FORM_DOMAIN + "/" + FormManager.getFormRecordId()
    );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
}
